import React, {ReactElement, ReactNode, useEffect} from 'react';
import {cx} from '@emotion/css';
import {FormikErrors} from 'formik';

import Button, {ButtonVariant} from '@fo/designSystem/Buttons/Button/Button';

import PageErrors from '../PageErrors/PageErrors';

import styles from './SinglePageForm.styles';

interface SinglePageFormProps<FormValues> {
  afterSubmitContent?: ReactNode;
  children: ReactNode;
  className?: string;
  errors?: FormikErrors<FormValues>;
  isClean?: boolean;
  isFormDisabled?: boolean;
  onLoad?: () => void;
  onSubmit: (formEvent: React.FormEvent<HTMLFormElement>) => void;
  submitButton?: {
    id: string;
    label: string;
    loading?: boolean;
    testId: string;
    onClick?: () => void;
  };
  hideErrorsListBox?: boolean;
}

function SinglePageForm<FormValues = unknown>({
  errors = {},
  afterSubmitContent,
  children,
  className,
  isClean,
  isFormDisabled,
  onSubmit,
  submitButton,
  hideErrorsListBox,
  onLoad = () => {
    // noop
  },
}: SinglePageFormProps<FormValues>): ReactElement {
  useEffect(() => {
    onLoad();
  }, []);

  return (
    <form noValidate className={cx(className)} onSubmit={onSubmit}>
      {children}
      {submitButton && (
        <div className={cx(styles.submitButton)}>
          <Button
            ariaLabel={submitButton.label}
            isDisabled={submitButton.loading || isFormDisabled || isClean}
            testId={submitButton.testId}
            id={submitButton.id}
            type="submit"
            variant={ButtonVariant.PRIMARY}
            onClick={() => {
              if (submitButton.onClick) {
                submitButton.onClick();
              }
            }}
          >
            {submitButton?.label}
          </Button>
        </div>
      )}
      {afterSubmitContent}
      {!hideErrorsListBox && Object.keys(errors).length > 0 && <PageErrors<FormValues> errors={errors} />}
    </form>
  );
}

export default SinglePageForm;
